import { getAmountWithCurrency } from 'utils/amountUtils';
import DateUtils from 'utils/dateUtils';
import { InvoiceStatus } from '../invoices.model';

export const calcLineItemTotal = (unitCost: number | string = 0, quantity: number | string = 0) => {
  if (unitCost === '.') {
    return null;
  }
  return getAmountWithCurrency(+unitCost * +quantity, '$');
};

export const isValidNumber = (value: string): boolean => {
  return value !== '' && !isNaN(+value);
};

export const getInvoiceRemainderDaysText = ({
  status,
  createdAt,
  lastTrnxDate
}: {
  status: InvoiceStatus;
  createdAt: string;
  lastTrnxDate: string;
}) => {
  let statusDate: Date;
  if (status === InvoiceStatus.PENDING) {
    statusDate = new Date(createdAt);
    const days = DateUtils.getDifferenceInDays({ secondaryDate: statusDate });
    if (days === 0) {
      return 'Since today';
    }
    return `Since ${days} ${days > 1 ? 'Days' : 'Day'}`;
  }
  statusDate = new Date(lastTrnxDate);
  const days = DateUtils.getDifferenceInDays({ secondaryDate: statusDate });
  if (days === 0) {
    return 'Today';
  }
  return `${days} ${days > 1 ? 'Days' : 'Day'} ago`;
};
